import React from "react";
import { IconButton, Stack, Text } from "@fluentui/react";
import { useTheme } from "../../../../theme/OAS365Theme";

/**
 * Server-side cursor-style pager: Previous / Next only (no total count or page numbers).
 */
const SimplePrevNextPagination = ({
  selectedPageIndex = 0,
  pageSize = 20,
  itemCount = 0,
  hasNext = false,
  hasPrevious = false,
  navigationLoading = false,
  onPageIndexChange,
}) => {
  const theme = useTheme();

  const canGoPrevious = hasPrevious && !navigationLoading;
  const canGoNext = hasNext && !navigationLoading;

  if (!canGoPrevious && !canGoNext && itemCount === 0) {
    return null;
  }

  const startRecord = itemCount > 0 ? selectedPageIndex * pageSize + 1 : null;
  const endRecord =
    itemCount > 0 ? selectedPageIndex * pageSize + itemCount : null;
  const rangeLabel =
    startRecord != null && endRecord != null
      ? `${startRecord} - ${endRecord}`
      : selectedPageIndex > 0
        ? `Page ${selectedPageIndex + 1}`
        : null;

  const buttonStyle = {
    root: {
      color: theme.colors.fontColor,
      background: theme.colors.backgroundColor,
      selectors: {
        "&.ms-Button--icon:disabled": {
          opacity: 0.4,
          color: theme.colors.fontColor,
          background: theme.colors.backgroundColor,
        },
        ".ms-Button-flexContainer:hover": {
          backgroundColor: `${theme.colors.msTeamsFilesHover}!important`,
          color: `${theme.colors.fontColor}!important`,
        },
      },
    },
  };

  return (
    <Stack
      horizontal
      horizontalAlign="center"
      verticalAlign="center"
      tokens={{ childrenGap: 4 }}
      aria-label="Document list pagination"
    >
      <IconButton
        title="Previous"
        aria-label="Previous page"
        disabled={!canGoPrevious}
        styles={buttonStyle}
        iconProps={{ iconName: "ChevronLeft" }}
        onClick={() => onPageIndexChange?.(selectedPageIndex - 1)}
      />
      {rangeLabel ? (
        <Text
          styles={{
            root: {
              fontFamily: theme.paggination?.fontFamily,
              fontSize: 11,
              color: theme.colors.fontColor,
              minWidth: 48,
              textAlign: "center",
              userSelect: "none",
            },
          }}
        >
          {rangeLabel}
        </Text>
      ) : null}
      <IconButton
        title="Next"
        aria-label="Next page"
        disabled={!canGoNext}
        styles={buttonStyle}
        iconProps={{ iconName: "ChevronRight" }}
        onClick={() => onPageIndexChange?.(selectedPageIndex + 1)}
      />
    </Stack>
  );
};

export default SimplePrevNextPagination;
